export function noop(): void {
  /* ignored */
}
